import * as constants from "./constants";

const initialState = {
  allTeacherAssign: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
  search: {},
};

const TeacherAssignReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_TEACHER_ASSIGN:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_TEACHER_ASSIGN_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allTeacherAssign: action.data,
        isAdding: false,
      };
    case constants.FETCH_TEACHER_ASSIGN_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };

    case constants.CREATE_TEACHER_ASSIGN:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_TEACHER_ASSIGN_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allTeacherAssign: [action.data, ...state.allTeacherAssign],
        isAdding: false,
      };
    case constants.CREATE_TEACHER_ASSIGN_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_TEACHER_ASSIGN:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_TEACHER_ASSIGN_SUCCESS:
      const updated = state.allTeacherAssign.map((el) =>
        el._id === action.data._id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allTeacherAssign: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_TEACHER_ASSIGN_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };
    case constants.SET_TEACHER_MANAGER_STATE:
      const { search } = state;

      localStorage.setItem(
        "teacherManagerState",
        JSON.stringify({ search, ...action.data })
      );
      return {
        ...state,
        ...action.data,
      };

    default:
      return state;
  }
};

export default TeacherAssignReducer;
